import {
  initializeApp,
  getApps
} from 'firebase/app';

import {
  getAuth,
  signOut,
  onAuthStateChanged,
  type User
} from 'firebase/auth';

import {
  toFriendlyAuthError
} from './auth/friendly-error';

const firebaseConfig = {
  apiKey: process.env.NEXT_PUBLIC_FIREBASE_API_KEY,
  authDomain: process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID,
  storageBucket: process.env.NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.NEXT_PUBLIC_FIREBASE_APP_ID,
  measurementId: process.env.NEXT_PUBLIC_FIREBASE_MEASUREMENT_ID
};

const app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApps()[0];

export const auth = getAuth(app);
export const signOutUser = () => signOut(auth);

export const userStateListener = (callback: (user: User | null) => void) =>
  onAuthStateChanged(auth, callback);

export const getToken = async (): Promise<string | null> => {

  const user = auth.currentUser;

  if (!user) {

    return null;
  }

  // Most pages call this inside a try block that shows err.message, so a
  // failure here (offline, session ended) leaves already in plain words.
  try {

    return await user.getIdToken();
  } catch (err) {

    throw toFriendlyAuthError(err, 'session');
  }
};
